
import {initWebComponent} from "@/helpers/web-component-helper";
import {
    getFeatureInfoByFeatureInfoKey
} from "@/helpers/plugin-helper";
import {Point} from "ol/geom";
import {WKT} from "ol/format";
import {Vector} from "ol/layer";
import {showPluginOnMap} from "@/helpers/ol/ol-plugin-helper";

export class LayerInfoInfoPluginOrbitComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        const featureInfoKey = this.getAttribute('data-feature-info-key')
        const featureKey = this.getAttribute('data-feature-key')

        const featureInfo = getFeatureInfoByFeatureInfoKey(featureKey, featureInfoKey)

        const record = featureInfo.records[0]
        const coordinates = record.geometry.coordinates

        const xy = coordinates[0] + ',' + coordinates[1]
        const url = window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/orbit?xy=' + xy

        let innerHTML = ``
        innerHTML += `
            <div class="embed-responsive embed-responsive-4by3 h-100">
                <iframe 
                    class="embed-responsive-item" 
                    seamless=""
                     allowtransparency="true" 
                     allowfullscreen="" 
                    src="` + url + `">
                </iframe>
            </div>
            `;

        template.innerHTML = innerHTML

        initWebComponent(this, template)
    }
}
